
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/snehova-historia",
      function () {
        return require("private-next-pages/[region]/[resort]/snehova-historia.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/snehova-historia"])
      });
    }
  